<template>
  <div>
    <AppPageHeader title="Create new project" />
    <div class="card">
      <ProjectForm
        v-if="isEmployee"
        :save-function="createProject"
      />
      <CustomerProjectForm v-else-if="isCustomer" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Project } from '@/models/project'
import ProjectForm from '../components/ProjectForm.vue'
import CustomerProjectForm from '../components/CustomerProjectForm.vue'
import { useHead } from '@unhead/vue'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'
import CustomerService from '@/services/CustomerService'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import { useMutation } from '@tanstack/vue-query'

useHead({ title: 'Create new project' })

const { isEmployee, isCustomer } = useAuth()
const router = useRouter()
const { notify } = useNotification()
const customerService = new CustomerService()

const { mutateAsync: createProject } = useMutation({
  mutationFn: (newProject: Project) => customerService.addProject(newProject.customerId, newProject),
  onSuccess: (project: Project) => {
    notify({ type: 'success', title: 'Success', text: 'Project created successfully' })
    router.push({ name: 'ShowProject', params: { projectId: project.id, customerId: project.customerId } })
  },
  onError: (error) => {
    notify({ type: 'error', title: 'Error', text: error.message || 'An error occurred while trying to create the project' })
  }
})

</script>
